/** Polish declension of "uczestnik" for a count (1 uczestnik, 2 uczestnicy, 5 uczestników). */
export function participantsWord(n: number): string {
  if (n === 1) return "uczestnik";
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
    return "uczestnicy";
  }
  return "uczestników";
}
